import {
  Input,
  Pagination,
  Table,
  useBulkSelection,
  useTableHelpers,
  useTablePagination,
} from '@teamsnap/snap-ui';
import { OrderLineItem } from 'components/pages/order-details';
import { LoadingType, useOrderDetails } from 'hooks/orderDetails';
import * as React from 'react';
import { useState } from 'react';
import OrderDetailsTableSkeleton from '../order-table-skeleton';
import CancelFeesModal from './cancel-fees-modal';
import { canCancelItem, getColumns } from './helpers';

const FeesList = () => {
  const [isCancelModalOpen, setCancelModalOpen] = useState<boolean>(false);
  const [rowsToCancel, setRowsToCancel] = useState<OrderLineItem[]>([]);

  const { order, loading } = useOrderDetails();

  const { rows, headerRow } = useTableHelpers({
    data: order?.lineItems ?? [],
    columns: { ...getColumns(onCancelRow) },
    initialSorting: {
      method: 'alpha',
      sortKey: 'participantName',
      acsending: true,
    },
  });

  const { currentPage, onPageChange, totalCount, currentRows, pageSize } =
    useTablePagination({
      rows,
      pageSize: 10,
    });

  const {
    rows: selectableRows,
    toggleSelectAll,
    allRowsSelected,
  } = useBulkSelection({
    rows: currentRows,
    isRowSelectable: canCancelItem,
    onChangeSelected: (selected: OrderLineItem[]) => setRowsToCancel(selected),
  });

  function onCancelRow(lineItem: OrderLineItem) {
    setRowsToCancel([lineItem]);
    setCancelModalOpen(true);
  }

  function onActionSelect(event: React.ChangeEvent<HTMLSelectElement>) {
    if (event.target.value === 'cancel') {
      setCancelModalOpen(true);
    }
  }

  const selectedRows = selectableRows.filter((row) => row.selected);

  return (
    <div className="u-padBottomXxl" data-testid="fees-table--body">
      {loading[LoadingType.GetOrder] ||
      loading[LoadingType.GetOverview] ||
      !order ? (
        <OrderDetailsTableSkeleton />
      ) : (
        <>
          <Input
            type="select"
            className="sui-w-2/12 sui-pb-1"
            disabled={!selectedRows.length}
            size="small"
            value={'actions'}
            onChange={onActionSelect}
            name="bulk_actions"
            options={[
              {
                label: selectedRows.length
                  ? `${selectedRows.length} selected`
                  : 'Actions',
                value: 'actions',
              },
              { label: 'Cancel Fees', value: 'cancel' },
            ]}
          />
          <Table
            data-testid="fees-table--table"
            rows={selectableRows}
            className="sui-overflow-x-scroll"
            headerRow={headerRow}
            toggleSelectAll={toggleSelectAll}
            allRowsSelected={allRowsSelected}
          />
          <Pagination
            className="sui-mt-3"
            {...{
              currentPage,
              onPageChange,
              totalCount,
              pageSize,
            }}
          />
        </>
      )}

      <CancelFeesModal
        fees={rowsToCancel}
        show={isCancelModalOpen}
        close={() => setCancelModalOpen(false)}
      />
    </div>
  );
};

export default FeesList;
